<template lang="pug">
  server-data(
    ref="serverData"
    v-bind="serverDataAttrs"
    searchFieldName="search[title]"
    v-slot:default="{ selectProps, loading, loadMoreItems, search }"
    :method="getCourseUnits"
  )
    v-autocomplete-more(
      v-bind="{ ...selectProps, ...$attrs }"
      v-model="value"
      label="Темы курса"
      item-text="title"
      return-object cache-items
      rounded filled
      @update:search-input="search"
      @load-more-items="loadMoreItems"
      @input="$emit('input', $event)"
    )
      template(v-slot:item="{ item, on }")
        v-list-item(
          :key="item.id"
          v-on="on"
        )
          v-list-item-content
            v-list-item-title {{ item.title }}
            v-list-item-subtitle {{ item.description }}
</template>

<script>
export default {
  name: 'SelectUnit',
  props: {
    value: { type: [Number, Object], default: null },
    course: { type: Number, required: true },
    serverDataAttrs: { type: Object, default: () => ({}) },
  },
  watch: {
    course() {
      this.$refs.serverData.init();
    },
  },
  methods: {
    getCourseUnits(val) {
      const params = {
        ...val,
        expand: 'lessons',
      };
      return this.$api.courses.courseUnitIndex(this.course, params);
    },
  },
};
</script>
